import {
  createDirectus,
  rest,
  readItems,
  readItem,
  readSingleton,
  createItem,
  aggregate,
  staticToken
} from '@directus/sdk';
import { isServer } from 'app/utility/helpers';

const BACKEND_BASE_URL =
  process.env.BACKEND_BASE_URL || 'http://localhost:8055';

const NEXT_PUBLIC_BACKEND_BASE_URL =
  process.env.NEXT_PUBLIC_BACKEND_BASE_URL || 'http://localhost:8055';

const serviceToken = process.env.BACKEND_SERVICE_TOKEN;

const directusClient = createDirectus(BACKEND_BASE_URL).with(
  rest({
    onRequest: options => ({ ...options, next: { revalidate: 60 } })
  })
);

const directusPublicClient = createDirectus(NEXT_PUBLIC_BACKEND_BASE_URL).with(
  rest({
    onRequest: options => ({ ...options, next: { revalidate: 60 } })
  })
);

const directusServiceClient = createDirectus(BACKEND_BASE_URL)
  .with(staticToken(serviceToken || ''))
  .with(rest());

const getFileUrl = (fileId: string, modified_on?: string) => {
  const modifiedParam = modified_on
    ? `?modified_on=${modified_on.replace(/[\:\-\.]/g, '')}`
    : '';
  return `${NEXT_PUBLIC_BACKEND_BASE_URL}/assets/${fileId}${modifiedParam}`;
};

const getDirectusClient = () => {
  const isBuildTime = process.env.IS_BUILD_TIME === 'true';
  if (isServer()) {
    return isBuildTime ? directusPublicClient : directusClient;
  }
  return directusPublicClient;
};

const fileFields = ['id', 'title', 'description', 'modified_on', 'type'];

const imageFields = [...fileFields, 'width', 'height'];

enum Collections {
  Menus = 'menus',
  Pages = 'pages',
  Branches = 'branches',
  Specialists = 'specialists',
  SpecialistsCategories = 'specialist_categories',
  Services = 'services',
  ServiceCategories = 'service_categories',
  ServiceBundles = 'service_bundles',
  Posts = 'posts',
  MassMediaPosts = 'mass_media_posts',
  PostCategories = 'post_categories',
  Settings = 'settings',
  Messengers = 'messengers',
  BranchesPageSettings = 'branches_page_settings',
  HomePageSettings = 'home_page_settings',
  PromoBanner = 'promo_banner',
  PromoBannerImportant = 'promo_banner_important',
  Prices = 'prices',
  Requests = 'requests',
  Reviews = 'reviews',
  LogItems = 'log_items',
  Products = 'products',
  ProductCategories = 'product_categories'
}

export {
  Collections,
  directusClient,
  directusPublicClient,
  directusServiceClient,
  readItems,
  readItem,
  readSingleton,
  createItem,
  aggregate,
  getFileUrl,
  getDirectusClient,
  fileFields,
  imageFields
};
